import React, { useContext } from 'react';
import { IBpaContext, BpaContext } from '../../bpaState/bpaContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import { Form } from 'antd';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, initialFormData, bpa } = useContext<IBpaContext>(BpaContext);

	const currentFormData = {
		bpa,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
